import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/button';
import Icon from '../../../components/appIcon';

const SuccessMessage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleContinueToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="space-y-6 text-center">
      {/* Success Icon */}
      <div className="flex justify-center">
        <div className="flex items-center justify-center w-16 h-16 bg-success/10 rounded-full">
          <Icon name="CheckCircle2" size={32} className="text-success" />
        </div>
      </div>

      {/* Success Message */}
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-foreground">Password Reset Successful!</h3>
        <p className="text-sm text-muted-foreground">
          Your password has been successfully updated. You can now log in with your new password.
        </p>
      </div>

      {/* Auto-redirect Notice */}
      <div className="bg-muted/50 border border-border rounded-lg p-4">
        <div className="flex items-center justify-center space-x-2">
          <Icon name="Clock" size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">
            Redirecting to login in <span className="font-medium text-foreground">{countdown}</span> seconds
          </span>
        </div>
      </div>

      {/* Manual Continue Button */}
      <Button
        variant="default"
        fullWidth
        onClick={handleContinueToLogin}
        iconName="ArrowRight"
        iconPosition="right"
      >
        Continue to Login
      </Button>

      {/* Security Notice */}
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} className="text-primary mt-0.5" />
          <div className="flex-1 text-left">
            <h4 className="text-sm font-medium text-foreground mb-1">Security Reminder</h4>
            <p className="text-xs text-muted-foreground">
              For your security, make sure to log out from all devices and keep your new password confidential. 
              If you didn't request this password reset, please contact your system administrator immediately.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;